import React from 'react';

import { ERROR_TITLES, SUCCESS_MESSAGES } from '../../constants';
import { useBoard, useDialogs } from '../../hooks';
import { deleteTask as apiDeleteTask } from '../../services/taskService';
import DeleteDialog from './DeleteDialog';

const DeleteTaskDialog = () => {
  const { removeTask } = useBoard();

  const {
    activeTask,
    handleCloseDeleteTaskDialog: handleClose,
    showDeleteTaskDialog: showDialog,
  } = useDialogs();

  const handleDelete = async (task) => {
    await apiDeleteTask(task.id);
    removeTask(task);
  };

  return (
    <DeleteDialog
      errorTitle={ERROR_TITLES.task.delete}
      isOpen={showDialog}
      item={activeTask}
      onClose={handleClose}
      onDelete={handleDelete}
      successMessage={SUCCESS_MESSAGES.task.delete}
    />
  );
};

export default DeleteTaskDialog;
